import { render, staticRenderFns } from "./NavbarGestor.vue?vue&type=template&id=5c2ae313"
import script from "./NavbarGestor.vue?vue&type=script&lang=js"
export * from "./NavbarGestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports